__turbopack_context__.v({
  "hotbox": "HotboxCtaStrip-module__EWzazq__hotbox",
  "hotboxCta": "HotboxCtaStrip-module__EWzazq__hotboxCta",
  "hotboxH3": "HotboxCtaStrip-module__EWzazq__hotboxH3",
  "hotboxInner": "HotboxCtaStrip-module__EWzazq__hotboxInner",
  "hotboxP": "HotboxCtaStrip-module__EWzazq__hotboxP",
  "hotboxes": "HotboxCtaStrip-module__EWzazq__hotboxes",
  "variantLeftBorder": "HotboxCtaStrip-module__EWzazq__variantLeftBorder",
  "variantLightGray": "HotboxCtaStrip-module__EWzazq__variantLightGray",
  "variantOrange": "HotboxCtaStrip-module__EWzazq__variantOrange",
});
